<template>
    <div>
        <h3 v-if="isMobile">{{ $t('master.changePassword') }}</h3>
        <text-box
            :label="$t('master.oldPassword')"
            inputType="password"
            @onChange="handleOldPasswordChange"
            :error="errors['oldPassword']"
        />
        <text-box
            :label="$t('master.newPassword')"
            inputType="password"
            @onChange="handleNewPasswordChange"
            :error="errors['newPassword']"
        />
        <text-box
            :label="$t('master.confirmNewPassword')"
            inputType="password"
            @onChange="handleConfirmPasswordChange"
            :error="errors['passwordConfirmation']"
        />
        <ion-button class="ion-float-start ion-padding-start ion-margin-top" @click="handleChangePassword">{{
            $t('master.changePassword')
        }}</ion-button>
    </div>
</template>

<script>
import TextBox from '@/components/TextBox.vue'
import { validatePasswordChange } from '@/utils/validators.js'
import AxiosController from '@/controllers/AxiosController.js'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'ChangePassword',
    components: { TextBox },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            errors: [],
            isMobile
        }
    },
    methods: {
        handleOldPasswordChange(value) {
            this.oldPassword = value
        },
        handleNewPasswordChange(value) {
            this.newPassword = value
        },
        handleConfirmPasswordChange(value) {
            this.confirmPassword = value
        },
        handleChangePassword() {
            this.errors = []

            const { error } = validatePasswordChange({
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                passwordConfirmation: this.confirmPassword
            })
            if (error) {
                error.details.forEach(err => {
                    this.$set(this.errors, err.path[0], err.message)
                })
                return
            }
            const data = {
                password: this.oldPassword,
                new_password: this.newPassword
            }
            AxiosController.post('change-password', data)
                .then(() => this.$router.push('/user/me'))
                .catch(({ response }) => {
                    this.$set(this.errors, 'oldPassword', response.data.error)
                })
        }
    }
}
</script>

<style>
ion-button {
    --border-radius: 20px;
}
</style>
